/** Recorrido local del portal de licencias. Solo localhost y solo ideeo.mx como ejemplo. */

const CHARGE_NOTICE = 'Al habilitarse las licencias te enviaremos la factura de los meses completos que faltan de este periodo, incluido el mes de la solicitud. No se prorratea por días.';

export function isLocalIdeeoLicenseDemo() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  if (host !== 'localhost' && host !== '127.0.0.1') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get('portal') === 'licencias' && params.get('demo') === 'ideeo';
}

export const IDEEO_DEMO_USER = {
  email: 'admin.ejemplo@ideeo.mx',
  displayName: 'Alex',
  domain: 'ideeo.mx'
};

export const IDEEO_DEMO_DELEGATES = [
  { email: 'solicitudes.ejemplo@ideeo.mx', name: 'Ejemplo' }
];

export function ideeoDemoCatalog() {
  return {
    success: true,
    autoActivationMinutes: 10,
    requiresClientPurchaseOrder: true,
    pendientes: [{
      id: 'demo-pendiente',
      cantidad: 1,
      sku_solicitado: 'Google-Workspace-Business-Starter',
      fecha_str: '25/10/2026, 09:10',
      minutesUntilActivation: null,
      auto_activation_enabled: false,
      client_po_required: true
    }],
    catalogo: [
      {
        id: 'Google-Workspace-Business-Starter',
        name: 'Google Workspace Business Starter',
        desc: 'Identidad digital y colaboración esencial.',
        bullets: [
          'Correo profesional con dominio personalizado y Gemini en Gmail.',
          '30 GB de almacenamiento agrupado por usuario.',
          'Meet hasta 100 participantes; Docs, Sheets, Slides y Chat.',
          'Google Vids, Keep, Sites, Forms y AppSheet Core.',
          'Soporte incluido por Plexarian.'
        ]
      },
      {
        id: 'Google-Workspace-Business-Standard',
        name: 'Google Workspace Business Standard',
        desc: 'Más almacenamiento y grabación de reuniones.',
        bullets: [
          '2 TB de almacenamiento agrupado por usuario.',
          'Meet hasta 150 participantes, con grabación y cancelación de ruido.',
          'Unidades compartidas y Gemini en Gmail, Docs, Meet y más.',
          'Firma electrónica, páginas de citas y Gemini Notebook ampliado.',
          'Soporte incluido por Plexarian.'
        ]
      },
      {
        id: 'Google-Workspace-Business-Plus',
        name: 'Google Workspace Business Plus',
        desc: 'Seguridad avanzada, Vault y eDiscovery.',
        bullets: [
          '5 TB de almacenamiento agrupado y Vault para eDiscovery.',
          'Meet hasta 500 participantes con seguimiento de asistencia.',
          'Gestión avanzada de endpoints y LDAP seguro.',
          'Gemini ampliado (mismo alcance de IA que Standard).',
          'Soporte incluido por Plexarian.'
        ]
      }
    ],
    billing: {
      offCycle: true,
      chargeNotice: CHARGE_NOTICE,
      requiresRazonChoice: true,
      razones: [
        { uuid: '85011930-6307-4e6d-b6be-a4b62fb9cb7d', legalName: 'IDEEO LABS' },
        { uuid: '4e53a82e-f826-446a-8ff2-0c3c432127c7', legalName: 'GRAFICAS CORONA J.E.' },
        { uuid: '92ccfff0-3704-4996-a589-13846d3c09f1', legalName: 'DATAGRAF DE MEXICO' },
        { uuid: 'd8f1bbcd-9341-4c8a-9e50-583d18018c95', legalName: 'ESTILO Y MAS' },
        { uuid: '08136040-0a8c-40d8-af05-b9b240b4aeb4', legalName: 'INMOBILIARIA GABRIEL MANCERA 1' }
      ],
      overdue: {
        blocked: true,
        showPaymentHelp: true,
        count: 1,
        portalUrl: 'https://app4.porcobrar.com/portal/d8f1bbcd-9341-4c8a-9e50-583d18018c95',
        manualUrl: 'https://drive.google.com/file/d/1Qndn4Kl42ETc8SJ9_B9XVIJBMT5J6I8H/view',
        videoUrl: 'https://drive.google.com/file/d/1XgsfMVDvE6xyZzca5IT5G2lZ87C0iaDh/view',
        steps: [
          'Entra a tu portal de pagos.',
          'Elige la factura, luego Pagar y Transferencia interbancaria SPEI.',
          'Copia banco, CLABE, referencia y total.',
          'Haz el SPEI desde tu banco con esos datos tal cual.',
          'En el portal, pulsa Entendido. Recibirás el correo «Pago realizado» cuando se aplique.'
        ],
        referenceNote: 'La referencia cambia cada mes. Una referencia anterior provoca el rechazo del pago.',
        delegateNote: '',
        invoices: [
          {
            code: 'PLXN-F--1772639141',
            legalName: 'ESTILO Y MAS',
            balance: 779.52
          }
        ]
      }
    }
  };
}
